import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import PromoFeature from 'wonderbly-components/lib/PromoFeature';
import Arrow from 'wonderbly-components/lib/Arrow';
import { localiseUrlII } from 'src/common/utils/format-localised-url';
import { useModel } from 'src/client/js/view/hooks';
import { replaceTextWithValues } from 'src/common/utils/text-replace';
import { trackMarketingCardItem } from '../tracking';

const SiteNavPromos = props => {
  const { countryModel } = useModel();

  return (
    <ul className={cx(
      'SiteNavLinksList',
      'SiteNavLinksList__promo-column',
      { [props.className]: props.className },
    )}>
      {props.items.map((item, idx) => (
        <li
          key={idx}
          className="SiteNavLinksList__link"
          onClick={() => trackMarketingCardItem(props.parentItemLabel, item.navLinkLabel)}>
          <PromoFeature
            promoFeatureType="solo"
            image={item.navLinkedDocument.backgroundImage}
            title={replaceTextWithValues(item.navLinkedDocument.title, {
              code: `${item.navLinkedDocument.code}`
            })}
            textPosition={item.navLinkedDocument.textPosition}
            code={item.navLinkedDocument.code}
            codeBackgroundColor={item.navLinkedDocument.codeBackgroundColor}
            codeTextColor={item.navLinkedDocument.codeTextColor}
            cta={item.navLinkedDocument.ctaText}
            ctaColor={item.navLinkedDocument.ctaColor}
            href={item.navLinkedDocument.href ? localiseUrlII(countryModel, item.navLinkedDocument.href) : null}
            invert={item.navLinkedDocument.invert}
          />
          <button className="SiteNavLinksList__button">
            <a
              className="SiteNavLinksList__link-text"
              href={
                item.navLinkedDocument.href
                  ? localiseUrlII(countryModel, item.navLinkedDocument.href)
                  : null
              }>
              {item.navLinkLabel}
            </a>
            <Arrow
              inline
              direction="right"
            />
          </button>
        </li>
      ))}
    </ul>
  );
};

SiteNavPromos.propTypes = {
  className: PropTypes.oneOf([PropTypes.string, PropTypes.boolean]),
  parentItemLabel: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      navLinkLabel: PropTypes.string,
      navLinkUrl: PropTypes.string,
    })
  ),
};

export default SiteNavPromos;

